import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import { toast } from 'react-toastify'
import { selectTranslations } from '../../services/i18n/i18nSlice'
import { setLoading } from '../../services/global/globalSlice'
import page_img from '../../components/Navigation/icons/verifica.svg'
import { fetchSubjects, fetchTopics } from './QuestionBankApi'
import SubjectsTab from './_components/SubjectsTab'
import TopicsTab from './_components/TopicsTab'
import QuestionsTab from './_components/QuestionsTab'

import './QuestionBank.css'

export default function QuestionBankHomeScreen() {
    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()

    const [activeTab, setActiveTab] = useState('subjects')
    const [topicsSubjectFilter, setTopicsSubjectFilter] = useState('')
    const [subjects, setSubjects] = useState([])
    const [topics, setTopics] = useState([])

    const loadSubjectsAndTopics = async () => {
        dispatch(setLoading(true))
        const [subjectsResponse, topicsResponse] = await Promise.all([fetchSubjects(), fetchTopics()])
        if (subjectsResponse.success && topicsResponse.success) {
            setSubjects(subjectsResponse.data || [])
            setTopics(topicsResponse.data || [])
        } else {
            toast.error(t.error.error_loading)
        }
        dispatch(setLoading(false))
    }

    useEffect(() => { loadSubjectsAndTopics() }, [])

    const handleViewTopics = (subject_id) => {
        setTopicsSubjectFilter(subject_id)
        setActiveTab('topics')
    }

    return (
        <section id="questionBankScreen">
            <div className="page_title">
                <img src={page_img} alt="" />
                <h1>{t.question_bank.page_title}</h1>
            </div>
            <Tabs activeKey={activeTab} onSelect={(key) => setActiveTab(key)} id="question_bank_tabs" className="mb-3 rounded_tabs" mountOnEnter>
                <Tab eventKey="subjects" title={t.question_bank.subjects}>
                    <SubjectsTab subjects={subjects} topics={topics} onDataChange={loadSubjectsAndTopics} onViewTopics={handleViewTopics} />
                </Tab>
                <Tab eventKey="topics" title={t.question_bank.topics}>
                    <TopicsTab subjects={subjects} topics={topics} onDataChange={loadSubjectsAndTopics} subjectFilter={topicsSubjectFilter} onSubjectFilterChange={setTopicsSubjectFilter} />
                </Tab>
                <Tab eventKey="questions" title={t.question_bank.questions}>
                    <QuestionsTab subjects={subjects} topics={topics} />
                </Tab>
            </Tabs>
        </section>
    )
}
